export default function ItemNotFoundPage({ itemDescription }: { itemDescription: string }) {
  return (
    <div className="text-danger">Unable to find the requested {itemDescription}</div>
  )
}